import { pagesContent } from "../pages/merged";
import { abortionArticles } from "../pages/abortion";
export const getAlternatives = (acticleId) => {
    const readingArticle = pagesContent[acticleId];
    const readingLeaning = readingArticle.bias;
    const alternativeLeaning = readingLeaning == "Right" ? "Left" : "Right";
    const isAbortionSet = Boolean(abortionArticles[acticleId]);
    const alternativeArticles = pagesContent.allIds.filter((id) => Boolean(abortionArticles[id]) === isAbortionSet && pagesContent[id].bias == alternativeLeaning);
    const shuffledIndices = Array.from({ length: alternativeArticles.length }, (_, i) => i).sort(() => Math.random() - 0.5);
    return {
        readingLeaning: readingLeaning.toLowerCase(),
        alternativeLeaning: alternativeLeaning.toLowerCase(),
        alternativeArticles: [alternativeArticles[0], alternativeArticles[1]],
    };
};
